<div class="card card-redlaboral m-4">
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-12">
        <button type="button" class="btn btn-outline-primary" (click)="goBack()">
          <i class="fa-solid fa-arrow-left me-2"></i> Volver al listado
        </button>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12">
        <h4 class="mt-0 mb-3 text-primary">
          <i class="fa-solid fa-user-tie me-2"></i>
          Detalles del Candidato
        </h4>
      </div>
    </div>

    <!-- Sección de carga -->
    <div *ngIf="isLoading" class="text-center my-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p class="mt-2">Cargando información del candidato...</p>
    </div>

    <!-- Sección cuando no se ha encontrado la información del candidato -->
    <div *ngIf="!isLoading && !isFound" class="alert alert-warning text-center" role="alert">
      No se ha encontrado la información del candidato solicitado.
    </div>

    <!-- Sección principal cuando se encontró la data -->
    <div *ngIf="!isLoading && isFound">
      <app-register-form-natural-person
        [showSaveButton]="false"
        [showSaveRegister]="false"
        [isEditMode]="false"
        [isViewMode]="true"
        [candidateData]="candidate"
        [candidateAddresses]="addresses">
      </app-register-form-natural-person>
    </div>
  </div>
</div>
